import { Box, IconButton, type IconButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { type NavLinkProps } from "react-router";

export const MobileBar = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down(910)]: {
    backgroundColor: `${theme.palette.background.default}`,
    zIndex: 1,
    width: "100%",
    position: "fixed",
    bottom: 0,
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: theme.spacing(1),
    paddingLeft: `${theme.spacing(1)}`,
    paddingRight: `${theme.spacing(1)}`,
    paddingTop: `${theme.spacing(0.5)}`,
    paddingBottom: `${theme.spacing(0.5)}`,
  },
}));

export const MobileBarItem = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  "& svg": {
    width: 28,
    height: 28,
  },
}));

export const MobileBarButton = styled(IconButton)<
  IconButtonProps | NavLinkProps
>(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  ":hover": {
    backgroundColor: "transparent",
  },
}));
